import { render, staticRenderFns } from "./userPaymentStratificationLTV.vue?vue&type=template&id=24fc83d4&scoped=true&"
import script from "./userPaymentStratificationLTV.vue?vue&type=script&lang=js&"
export * from "./userPaymentStratificationLTV.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24fc83d4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\datacenter_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('24fc83d4')) {
      api.createRecord('24fc83d4', component.options)
    } else {
      api.reload('24fc83d4', component.options)
    }
    module.hot.accept("./userPaymentStratificationLTV.vue?vue&type=template&id=24fc83d4&scoped=true&", function () {
      api.rerender('24fc83d4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/datalist/userPaymentStratificationLTV.vue"
export default component.exports